import { ref } from "firebase/storage"
import { storage } from "./firebase.services"

const createFileRef = (path) => {
  return ref(storage, path);
}

export default createFileRef;